import React, { Component } from "react";


function obtenerTipoMensaje(tipo){
  switch(tipo){
    case "INFO":
      return ("fas fa-exclamation-circle card-fa-icono-info");
    case "WARN":
      return ("alert alert-warning");
    case "ERROR":
      return ("fas fa-exclamation-triangle card-fa-icono-error");
    case "ENTRUST":
      return ("fas fa-info-circle card-fa-icono-entrust")
    
  }
}

function dibujarCardTipo(tipo){
  switch(tipo){
    case "INFO":
      return ("info-box info-login-info");
    case "WARN":
      return ("info-box info-login");
    case "ERROR":
      return ("info-box info-login-error");
    case "ENTRUST":
      return ("info-box info-login-entrust");
  }
}

export default class MensajeUsuario extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    
  }


  render(props) {  
      return (
       <div className="col-md-12">
        <div className={dibujarCardTipo(this.props.tipo)}>
          <span className="info-box-icon bg-info info-login-icon">
              <i className={obtenerTipoMensaje(this.props.tipo)}/>
          </span>
          <div className="info-box-content">
              <span className="info-box-text info-login-text" style={{color: "white", fontSize:"18px"}}>
                {this.props.mensaje} 
              </span>
          </div>
      </div>
      </div>
      );
  }
}